import { render, staticRenderFns } from "./CollectionDiffUser.vue?vue&type=template&id=71a397bf"
import script from "./CollectionDiffUser.vue?vue&type=script&lang=js"
export * from "./CollectionDiffUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports